import React, { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { useCommonStyles } from '../../../utils/admin/StyleHook'
import useT from '../../../i18ns/admin/useT'
import { useDialogHandleClick } from '../../../utils/default/ComplexFlowHook'
import useGlobalDialog from '../../../providers/admin/dialog/useGlobalDialog'
import { createGlobalDialogConfig } from '../../../utils/default/DialogHelper'
import useGDK from '../../../providers/admin/gdk/useGDK'
import allRoute from '../route/route'
import DepositWayGroupDialogDropdown from './DepositWayGroupDialogDropdown'
import { DepositMethodType } from '@golden/gdk-campaign'
import { PiggyWechat } from '@golden/gdk-admin'

interface PropTypes {
  item: PiggyWechat
  reload: () => void
}

const FinancePiggyWechatButtons: React.FC<PropTypes> = (props) => {
  const { item, reload } = props
  const classes = useCommonStyles()
  const globalDialog = useGlobalDialog()
  const gdk = useGDK()
  const { t } = useT()
  const [groupId, setGroupId] = useState<number | '--'>(item.group?.id ?? '--')
  const handleDropdownChange = useCallback((event) => {
    const val = event.target.value as number | '--'
    setGroupId(val)
  }, [setGroupId])
  const handleStart = useDialogHandleClick({
    dialogId: `startPiggyWechat-${item.id}`,
    globalDialog,
    changeDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      message: (
        <DepositWayGroupDialogDropdown
          targetId={item.id}
          method={DepositMethodType.SCAN_WECHAT}
          targetCashText={`${item.name} [${item.cash_min} - ${item.cash_max}]`}
          groupId={groupId}
          handleOnChange={handleDropdownChange}
        />
      )
    }),
    successDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      showCancel: false,
      message: t('dialog.startPiggyWechatSuccess')
    }),
    getFailDialogConfig: (error) => createGlobalDialogConfig({
      showIcon: true,
      variant: 'error',
      showCancel: false,
      message: error
    }),
    payload: item.id,
    gdkFunc: (payload) => gdk.finance.togglePiggyWechat(payload, { is_active: true, group_id: groupId === '--' ? null : groupId }),
    gdkFuncDependencies: [gdk, groupId],
    onSuccess: () => { reload() }
  })
  const handleStop = useDialogHandleClick({
    dialogId: `stopPiggyWechat-${item.id}`,
    globalDialog,
    changeDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      message: (
        <React.Fragment>
          {t('dialog.confirmStopPiggyWechat')}
          <span className={classes.purpleWord}>{item.account} {item.name}</span>
        </React.Fragment>
      )
    }),
    successDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      showCancel: false,
      message: t('dialog.stopPiggyWechatSuccess')
    }),
    getFailDialogConfig: (error) => createGlobalDialogConfig({
      showIcon: true,
      variant: 'error',
      showCancel: false,
      message: error
    }),
    payload: item.id,
    gdkFunc: (payload) => gdk.finance.togglePiggyWechat(payload, { is_active: false, group_id: groupId === '--' ? null : groupId }),
    gdkFuncDependencies: [gdk, groupId],
    onSuccess: () => { reload() }
  })
  /* const handleDelete = useDialogHandleClick({
    dialogId: `deletePiggyWechat-${id}`,
    globalDialog,
    changeDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      message: (
        <React.Fragment>
          {t('dialog.confirmDeleteWechat')}
          <span className={classes.purpleWord}>{account} {name}</span>
        </React.Fragment>
      )
    }),
    successDialogConfig: createGlobalDialogConfig({
      showIcon: false,
      showCancel: false,
      message: t('dialog.deleteWechatSuccess')
    }),
    getFailDialogConfig: (error) => createGlobalDialogConfig({
      showIcon: true,
      variant: 'error',
      showCancel: false,
      message: error
    }),
    payload: id,
    gdkFunc: (payload) => gdk.finance.deletePiggyWechat(payload),
    gdkFuncDependencies: [gdk],
    onSuccess: () => reload()
  }) */
  return (
    <Grid container direction="column" justifyContent="center" spacing={2}>
      <Grid item>
        <Button
          component={Link}
          to={allRoute.financePiggyWechatUpdate.encodePath({ param: { id: item.id }, search: {} })}
          className={classes.blueGradualOutlineButton}
        >
          {t('common.update')}
        </Button>
      </Grid>
      {item.is_active
        ? (
        <Grid item>
          <Button
            className={classes.greyOutlineButton}
            onClick={handleStop}
          >
            {t('common.toggleOff')}
          </Button>
        </Grid>
          )
        : (
        <Grid item>
          <Button
            className={classes.greenGradualOutlineButton}
            onClick={handleStart}
          >
            {t('common.toggleOn')}
          </Button>
        </Grid>
          )}
      {/*
      <Grid item>
        <Button
          className={classes.pinkGradualOutlineButton}
          onClick={handleDelete}
        >
          {t('common.delete')}
        </Button>
      </Grid>
      */}
    </Grid>
  )
}

export default React.memo(FinancePiggyWechatButtons)
